import { TabsProps } from "antd"

import { IFuel } from "@/types/IFuel"
import { IFuelQuote } from "@/types/IFuelQuote"
import { DeliveryType, OrderStatusTabKeys } from "@/types/IOrder"


export interface IBulkOrder {
	id: number
	startDate: string
  	endDate: string
	createdOn: string
	acceptDate: Date
	deliveryType: DeliveryType
	deliveryTypeText: string
	amount: number
	totalFuelQuantity:number
	totalRemainder: number
	customerId: number
	customerName: string
	depotName: string
	depotId: number
	status: BulkOrderStatus
	timerAdminDuration?: number
	timerAdminStart?: string
	timerCustomerDuration?: number
	timerCustomerStart?: string
	statusText: string
	fuels: IBulkOrderFuel[]
	transports: IBulkOrderTransport[]
	logs: IBulkOrderLog[]
	isPersonalOffer: boolean
}

export interface IBulkOrderCreate {
	startDate: string | Date
  	endDate: string | Date
	deliveryType: DeliveryType
	customerIds: number[]
	depotId: number
	fuels: IBulkOrderFuelCreate[]
	isPersonalOffer: boolean
}

export interface IBulkOrderUpdate extends IBulkOrderCreate{
	id: number
}

export interface IBulkOrderChangeStatus{
	bulkOrderId: number
	status: BulkOrderStatus
}

export interface IBulkOrderFuel {
  	id: number
  	quantity: number
  	offeredPrice?: number
	fuel: IFuel
	shippingSchedules?: IShippingSchedule[]		
}

export interface IBulkOrderTransport {
  	driverName: string
	transportName: string
	date: Date
	orderId: number
}

export interface IShippingSchedule {
	guid: string
	id?: number
  	quantity: number
	remainderFuel?: number
	price?: number
	startDate: Date | string
	endDate: Date | string
	isTransportSelect?: boolean
	fuelTypeId?: number
	fuelTypeName?: string
	lastSetPrice?: number
	fuelQuotes?: IFuelQuote[]
} 

export interface IBulkOrderFuelCreate {
	guid?: string
	id?: number
  	fuelTypeId: number
	fuelTypeName: string
  	quantity: number
  	offeredPrice?: number
	fuel?: IFuel
	shippingSchedules?: IShippingSchedule[]		
}

export interface IBulkOrdersDelete {
  	ids: number[]
}

export interface IBulkOrderLog {
	bulkOrderId: number
	event: BulkOrderLogEvent
	changesTypes: BulkOrderLogChangeType[]
	currentValue: string
	prevValue: string
}

export interface IBulkOrderFuelLog {
  	Id: number
	DepotId: number
	FuelTypeId: number
  	Quantity: number
  	OfferedPrice?: number	
}

export enum BulkOrderStatus {
  	InProcess = 1,
	Canceled,
	CurrentOffer,
	Accept,
	Closed
}

export enum BulkOrderLogEvent {
  	Created = 0,
	Updated = 1,
	Deleted = 2,
	ChangedStatus = 3
}

export enum BulkOrderStateRequest {
	PersonalOffer,
    RequestQuote,
    BulkOrder
}

export enum BulkOrderLogChangeType {
  	ChangeStatus = 0,
	ChangeDeliveryType = 1,
	ChangeStartDate = 2,
	ChangeEndDate = 3,
	ChangeCustomerId = 4,
	ChangeDepotId = 5,
	ChangeFuels = 6,
}

export const bulkOrderStatuses = [
  {
	name: "В обработке",
	type: BulkOrderStatus.InProcess
  },
  {
	name: "Отклонен",
	type: BulkOrderStatus.Canceled
  },
  {
	name: "Действующее предложение",
	type: BulkOrderStatus.CurrentOffer
  },
  {
	name: "Принят",
	type: BulkOrderStatus.Accept
  },
  {
	name: "Закрыт",
	type: BulkOrderStatus.Closed
  }
]

export const BulkOrderStatusTabs: TabsProps["items"] = [
  {
	key: OrderStatusTabKeys.All,
	label: "Все"
  },
  {
	key: OrderStatusTabKeys.InProcess,
	label: "В работе"
  },
  {
	key: OrderStatusTabKeys.Archive,
	label: "Архив"
  }
]

export const PersonalOfferTabs: TabsProps["items"] = [
{
	key: OrderStatusTabKeys.All,
	label: "Все"
  },
  {
	key: OrderStatusTabKeys.Active,
	label: "Активные"
  },
  {
	key: OrderStatusTabKeys.Archive,
	label: "Архив"
  }
]

export const RequestQuoteTabs: TabsProps["items"] = [
{
	key: OrderStatusTabKeys.All,
	label: "Все"
  },
  {
	key: OrderStatusTabKeys.Active,
	label: "Активные"
  },
  {
	key: OrderStatusTabKeys.Archive,
	label: "Архив"
  }
]


export const BULK_ORDER_KEY = "BULK_ORDER_KEY"
export const PERSONAL_OFFER_KEY = " PERSONAL_OFFER_KEY"
export const REQUEST_QUOTE_KEY = "REQUEST_QUOTE_KEY"

